import { Routes } from '@angular/router';
import { loginGuard } from '@us/web/auth/data-access';
import { RouterUtil } from '@us/web/shared/utils';
import { TabsPage } from '../tabs/tabs.page';
import { MainPage } from './main.page';
import { MobilePageComponent } from '@us/web/layout/ui';

export const routes: Routes = [
    {
        path: '',
        component: MainPage,
        children: [
            {
                path: '',
                component: TabsPage,
                children: [
                    {
                        path: RouterUtil.Cog.Home,
                        // canActivate: [handleBranchesGuard],
                        loadChildren: () => import('../home/routes').then(m => m.routes)
                    },
                    // {
                    //     path: RouterUtil.Cog.Stores,
                    //     providers: [provideState(storesFeature), provideEffects(StoresEffects)],
                    //     loadChildren: () => import('@us/web/stores/feature').then(m => m.routes)
                    // },
                    {
                        path: RouterUtil.Cog.Cart,
                        loadChildren: () => import('@us/web/cart/feature').then(m => m.routes)
                    },
                    {
                        path: RouterUtil.Cog.Products,
                        loadChildren: () => import('@us/web/categories/feature').then(m => m.routes)
                    },
                    {
                        path: RouterUtil.Cog.Account,
                        loadChildren: () => import('@us/web/account/feature').then(m => m.routes)
                    },
                    { path: '', redirectTo: RouterUtil.Cog.Home, pathMatch: 'full' }
                ]
            },
            {
                path: RouterUtil.Cog.Shops,
                component: MobilePageComponent,
                data: {
                    title: 'store'
                },
                loadChildren: () => import('@us/web/shops/feature').then(m => m.routes)
            },
            // {
            //     path: RouterUtil.Cog.SelectStore,
            //     loadChildren: () => import('@us/web/shops/feature').then(m => m.routes)
            // },
            {
                path: RouterUtil.Cog.Checkout,
                redirectTo: RouterUtil.Cog.Cart,
                pathMatch: 'full'
            },
            {
                path: RouterUtil.Cog.Orders,
                redirectTo: RouterUtil.Cog.Account + '/' + RouterUtil.Cog.Orders
            },
            {
                path: RouterUtil.Cog.DeliveryAddresses,
                canActivate: [loginGuard],
                loadChildren: () => import('@us/web/delivery-addresses/feature').then(m => m.routes)
            },
            {
                path: RouterUtil.Cog.SelectDeliveryAddress,
                canActivate: [loginGuard],
                loadChildren: () => import('@us/web/delivery-addresses/feature').then(m => m.routes)
            },
            {
                path: RouterUtil.Cog.Login,
                loadChildren: () => import('@us/web/auth/feature').then(m => m.routes)
            },
            {
                path: RouterUtil.Cog.Notifications,
                loadChildren: () => import('../notifications/notifications.module').then(m => m.NotificationsPageModule)
            },
            {
                path: RouterUtil.Cog.Shop,
                loadChildren: () => import('@us/web/shop/feature').then(m => m.routes)
            },
            { path: RouterUtil.Cog.About, loadChildren: () => import('@us/web/about/feature').then(m => m.routes) }
        ]
    }
];
